module.exports = __webpack_public_path__ + "img/2.ae897e76.png";